import { Text, View } from '@react-pdf/renderer';
import { Term } from '../../../../models/courses/term';
import { CoursePDFStyles } from '../course-details-pdf-css';
import { MessageKeys } from 'next-intl';
import { CountryCode } from '../../../../constants/country';
import { formatMonthfromDate } from '../../../../utils/string-helpers/formatting.helper';
export function generateImportantDatesRow(
  terms: Term[],
  programLength: number,
  locale: string,
  styles: CoursePDFStyles,
) {
  const datesRow = terms.map((term, index) => {
    const forFirstRow =
      index === 0 ? (
        <Text key={`duration-${index}`} style={[styles.dateColumn]}>
          <Text style={styles.paragraph}>{programLength}</Text>
        </Text>
      ) : null;

    return (
      <View key={`dateV-${index}`} style={[styles.tableRow, styles.tableRowMargin10]}>
        <Text key={`sdate-${index}`} style={[styles.dateColumn]}>
          <Text style={styles.paragraph}>{term.startDateString}</Text>
        </Text>
        <Text key={`edate-${index}`} style={[styles.dateColumn]}>
          <Text style={styles.paragraph}>{term.endDateString}</Text>
        </Text>
        {forFirstRow}
      </View>
    );
  });

  return (
    <>
      <View style={styles.tableRow}>
        <Text style={[styles.dateColumn]}>
          <Text style={styles.paragraphHeading}>Start Date</Text>
        </Text>
        <Text style={[styles.dateColumn]}>
          <Text style={styles.paragraphHeading}>End Date</Text>
        </Text>
        <Text style={[styles.dateColumn]}>
          <Text style={styles.paragraphHeading}>Length</Text>
        </Text>
      </View>
      <View key={`dates`}>{datesRow}</View>
    </>
  );
}

export function generateImportantDatesRowUSPathway(
  terms: Term[],
  termName: string,
  translations: any,
  styles: CoursePDFStyles,
) {
  const groupBy = (array, key) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  };

  const groupedData = groupBy(terms, 'instanceId');

  const importantDatesSeparator = <View style={[styles.tableRow, styles.divider]}></View>;
  const datesRows = Object.entries(groupedData).map(([instanceId, records], index) => {
    return (
      <>
        <View>
          <Text style={[styles.paragraphDateHeading]}>
            <>
              {records[0].startDate.getFullYear()}{' '}
              {translations(records[0].seasonDescription.translationKey as MessageKeys<any, any>)}
              {' Start ('}
              {formatMonthfromDate(records[0].startDateString, records[0].locale)}
              {')'}
            </>
          </Text>
        </View>
        <View>
          <Text style={[styles.paragraphDate]}>
            {records[0].countryCode == CountryCode.US
              ? translations('Courses.importantDates.courseSynonymUS')
              : translations('Courses.importantDates.courseSynonymUK')}{' '}
            {translations('Courses.importantDates.startDate')} : {records[0].startDateString} -{' '}
            {records[0].countryCode == CountryCode.US
              ? translations('Courses.importantDates.courseSynonymUS')
              : translations('Courses.importantDates.courseSynonymUK')}{' '}
            {translations('Courses.importantDates.endDate')}:{' '}
            {records[Array.isArray(records) && records.length - 1].endDateString}
          </Text>
        </View>
        {Array.isArray(records) &&
          records.map((term, count) => {
            return (
              <>
                <View key={`dateV-${count}`}>
                  <Text key={`sdate-${count}`} style={[styles.paragraphDate]}>
                    {!!term.seasonDescription && (
                      <>
                        {translations(term.seasonDescription.translationKey)} {termName}:{' '}
                      </>
                    )}

                    {term.startDateString}
                    {' - '}
                    {term.endDateString}
                  </Text>
                </View>
              </>
            );
          })}

        {index !== groupedData.length - 1 ? importantDatesSeparator : null}
      </>
    );
  });
  return <View key={`dates`}>{datesRows}</View>;
}
